import * as React from "react";
import { FileUp } from "lucide-react";
import { Input } from "./input";
/**
 * @example
 *
 * ```jsx
 * import { FileDropZone } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <FileDropZone
 *       multiple
 *       disabled={false}
 *       onFiles={(files) => console.log(files)}
 *       title="Dateien auswählen oder hier ablegen"
 *       hint="Pro Datei sind maximal 1,4 MB möglich."
 *     />
 *   )
 * }
 * ```
 */
const FileDropZone = ({ title, hint, accept, multiple, disabled, onFiles, }) => {
    const [dragActive, setDragActive] = React.useState(false);
    const handle = (files) => {
        if (files && files.length > 0) {
            onFiles(Array.from(files));
        }
    };
    return (React.createElement("label", { onDragEnter: (event) => {
            event.preventDefault();
            setDragActive(true);
        }, onDragOver: (event) => {
            event.preventDefault();
            event.dataTransfer.dropEffect = "copy";
        }, onDragLeave: (event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
                setDragActive(false);
            }
        }, onDrop: (event) => {
            event.preventDefault();
            setDragActive(false);
            if (!disabled) {
                handle(event.dataTransfer.files);
            }
        }, className: `flex min-h-36 flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-6 text-center ${disabled
            ? "cursor-not-allowed opacity-60"
            : dragActive
                ? "cursor-pointer border-primary bg-muted"
                : "cursor-pointer border-border hover:bg-muted/50"}` },
        React.createElement(FileUp, { className: "h-8 w-8 text-muted-foreground" }),
        React.createElement("span", { className: "text-sm font-semibold" }, title),
        !!hint && React.createElement("span", { className: "text-xs text-muted-foreground" }, hint),
        React.createElement(Input, { className: "sr-only", type: "file", accept: accept, multiple: multiple, disabled: disabled, onChange: (event) => {
                const files = event.target.files;
                event.target.value = "";
                handle(files);
            } })));
};
export { FileDropZone };
//# sourceMappingURL=file-drop-zone.js.map